import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import toast from 'react-hot-toast';
import { 
  ChatBubbleLeftRightIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const StartConversation = ({ project, isOpen, onClose }) => {
  const queryClient = useQueryClient();
  const [message, setMessage] = useState('');

  const sendMessageMutation = useMutation(
    async (messageData) => {
      const response = await axios.post('/api/messages', messageData);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('conversations');
        toast.success('Message envoyé avec succès !');
        setMessage('');
        onClose();
      },
      onError: (error) => {
        console.error('Erreur envoi message:', error);
        toast.error('Erreur lors de l\'envoi du message');
      }
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    sendMessageMutation.mutate({
      recipientId: project.authorId,
      content: `Bonjour, je suis intéressé par votre projet "${project.title}". ${message.trim()}`
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-text flex items-center">
              <ChatBubbleLeftRightIcon className="h-5 w-5 mr-2" />
              Contacter l'entrepreneur
            </h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <XMarkIcon className="h-5 w-5 text-gray-500" />
            </button>
          </div>

          <div className="mb-4 p-3 bg-gray-50 rounded-lg">
            <h3 className="font-medium text-text">{project.title}</h3>
            <p className="text-sm text-gray-600">par {project.author.name}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Votre message
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Bonjour, je suis intéressé par votre projet..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
                rows={4}
                required
              />
            </div>

            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={!message.trim() || sendMessageMutation.isLoading}
                className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {sendMessageMutation.isLoading ? 'Envoi...' : 'Envoyer'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StartConversation;
